import React, { createContext, useContext, useMemo, useState, useEffect } from 'react';

const ModulePageExtraContext = createContext(null);

export function ModulePageExtraProvider({ children }) {
  const [pageExtra, setPageExtra] = useState(null);
  const value = useMemo(() => ({ pageExtra, setPageExtra }), [pageExtra]);
  return (
    <ModulePageExtraContext.Provider value={value}>{children}</ModulePageExtraContext.Provider>
  );
}

export function useModulePageExtraValue() {
  return useContext(ModulePageExtraContext)?.pageExtra ?? null;
}

/** Enregistre des actions dans l'en-tête du module (titleExtra). */
export function useModulePageExtra(node) {
  const ctx = useContext(ModulePageExtraContext);
  useEffect(() => {
    if (!ctx) return undefined;
    ctx.setPageExtra(node);
    return () => ctx.setPageExtra(null);
  }, [ctx, node]);
}
